import '../styles/pages/nutrition-coaching.scss';
import { FaUtensils, FaCalendarAlt, FaHeart, FaChartLine, FaHandshake } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import pn1Certified from '../img/nutrition/pn1-certified.png';

const NutritionCoaching = () => {
  const services = [
    {
      icon: <FaUtensils />,
      title: 'Personalized Nutrition Plans',
      description: 'Customized meal plans tailored to your goals and preferences'
    },
    {
      icon: <FaCalendarAlt />,
      title: 'Meal Planning & Preparation',
      description: 'Learn how to plan and prepare nutritious meals efficiently'
    },
    {
      icon: <FaHeart />,
      title: 'Lifestyle Coaching',
      description: 'Develop sustainable habits for long-term health success'
    },
    {
      icon: <FaChartLine />,
      title: 'Progress Tracking',
      description: 'Monitor your achievements and adjust plans accordingly'
    },
    {
      icon: <FaHandshake />,
      title: 'Ongoing Support',
      description: 'Regular check-ins and accountability to keep you on track'
    }
  ];

  return (
    <div className="nutrition-coaching">
      <div className="nutrition-coaching__hero">
        <div className="nutrition-coaching__hero-content">
          <h1 className="nutrition-coaching__title">
            Nutrition Coaching
          </h1>
          <p className="nutrition-coaching__subtitle">
            Personalized Nutrition Plans & Lifestyle Coaching
          </p>
          <div className="nutrition-coaching__credential">
            <img src={pn1Certified} alt="PN1 Certified Nutrition Coach" className="nutrition-coaching__credential-image" />
          </div>
          <Link to="/contact" className="nutrition-coaching__cta-button">
            Start Your Journey
          </Link>
        </div>
      </div>

      <div className="nutrition-coaching__container">
        <div className="nutrition-coaching__content">
          <div className="nutrition-coaching__description">
            <p>
            Build lasting healthy habits with personalized, science-backed nutrition coaching. I'll help you create a sustainable approach to eating that fits your lifestyle and moves you toward your health goals.
            </p>
          </div>

          <div className="nutrition-coaching__services">
            <h2>Our Services</h2>
            <div className="nutrition-coaching__services-grid">
              {services.map((service, index) => (
                <div key={index} className="nutrition-coaching__service-card">
                  <div className="nutrition-coaching__service-icon">
                    {service.icon}
                  </div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NutritionCoaching; 